import { cn } from 'noddi-ui-common';

interface LinearProgressProps {
  className?: string;
  wrapperClassName?: string;
}

export const NoddiLinearProgressLoader = ({ className, wrapperClassName }: LinearProgressProps) => {
  return (
    <div className={cn('relative w-full min-w-24 overflow-hidden rounded-full bg-secondary', wrapperClassName)}>
      <div className={cn('h-1 w-full animate-progress-indeterminate bg-primary', className)} />
    </div>
  );
};
